import React, { useState } from "react";
import EmployDetailsForm from "./EmployDetailsForm";
import SelectMaterialForm from "./SelectMaterialForm";
import { useFetchDropdown } from "../../../issuanceIDcard/customhooks";
import ALoader from "views/pages/manage/common/a-loader";
import IssueStockConfirmation from "../../selectMeterialAndStock/issueStock/IssueStockConfirmation";
import {
  createRequestFormat,
  employeeDetailsFormFields,
  useFetchSapCostCenter,
  verifyEmpId,
} from "./helper";
import { issueNonBarcodedStock, issueStockApi } from "../../service";
import IssueStockSuccessPrompt from "../../selectMeterialAndStock/issueStock/IssueStockSuccessPrompt";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { successToast } from "../../../../common/utils/methods/toasterFunctions/function";
import { ERROR_MGS_WHILE_SAP_DOWN } from "../../constant";
const IssueStockForm = ({ isDlp, sapPostingDate, academicType }) => {
  // forms
  const [employeeDetailsForm, setEmployeeDetailsForm] = useState(
    employeeDetailsFormFields
  );
  const [selectedMaterials, setSelectedMaterials] = useState([]);
  const [selectedNonBarcodedMaterials,setSelectedNonBarcodedMaterials]= useState([]);
  const [isEmpIdVerified, setEmpIdVerified] = useState(false);
  const [isErrorWhileVerify, setErrorWhile] = useState(false);
  const [type,setType]=useState('')
  const [isLoading, setLoading] = useState(false);

  // dropdown
  const [dropdown, isDropdownLoading] = useFetchDropdown(academicType);
  const sapCostDropdown = useFetchSapCostCenter(
    employeeDetailsForm?.businessArea
  );

  const [issuedSuccess, setIssuedSuccess] = useState(false);
  const [successResponse, setSuccessResponse] = useState({});
  const [issueStockConfirmation, setIssueStockConfirmation] = useState(false);

  const employeeFormHandler = (value, key,type) => {
    if (key === "psid") {
      setEmpIdVerified(false);
      setErrorWhile(false);
    }
    if(key=='s3key'||key=='fileName'){
      setEmployeeDetailsForm((prev) => ({ ...prev, [type]:{...prev?.[type],[key]: value }}));
    }
    else{
      setEmployeeDetailsForm((prev) => ({ ...prev, [key]: value }));
    }
    
  };

  const issueStockHandler = async (type='') => {
    try {
      if (
        employeeDetailsForm?.businessArea === "" ||
        employeeDetailsForm?.reason === "" ||
        employeeDetailsForm?.transactionType === "" ||
        employeeDetailsForm?.reason === "" ||
        employeeDetailsForm?.sapCostCenter === "" ||
        employeeDetailsForm?.psid === ""
      ) {
        failureToast("Please select all  required field");
        return;
      }
      if (!isEmpIdVerified) return failureToast("Please verify empID ");

      if (selectedMaterials.length === 0&& type=='barcoded') {
        failureToast("Please add a material details");
        return;
      }
      if (selectedNonBarcodedMaterials.length === 0&& type=='nonBarcoded') {
        failureToast("Please add a material details");
        return;
      }
      if (!employeeDetailsForm?.[type]?.s3key) {
        failureToast("Please add attachment file");
        return;
      }
      setIssueStockConfirmation(true);
      setType(type)
    } catch (error) {}
  };
  const onSuccessCancel = () => {
    setIssuedSuccess(false);
    successResponse({});
  };

  const onAgree = async (type) => {
    try {
      setLoading(true);
      setIssueStockConfirmation(false);
      const request = createRequestFormat(
        employeeDetailsForm,
        selectedMaterials,
        academicType,
        selectedNonBarcodedMaterials,
        type
      );
      request["sapPostingDate"] = sapPostingDate;
      const response = type=='nonBarcoded'?await issueNonBarcodedStock(request):await issueStockApi(request);
      if (response?.code === 200) {
        successToast("Request completed successfully");
        setIssuedSuccess(true);
        setSuccessResponse(response?.data);
        setEmployeeDetailsForm({ ...employeeDetailsFormFields });
        setSelectedMaterials([]);
        setSelectedNonBarcodedMaterials([])
        setEmpIdVerified(false);
      } else {
        failureToast(`${response?.message} \n 
         Branch Consumption ID : ${response?.data.transactionId} failed. ${ERROR_MGS_WHILE_SAP_DOWN}`);
      }
    } catch (error) {}
    finally{
      setLoading(false);
    }
  };

  const verifyEmpIdHandler = async () => {
    if (employeeDetailsForm?.psid === "")
      return failureToast("Please enter a valid Employee ID");

    try {
      setLoading(true);
      const response = await verifyEmpId(employeeDetailsForm?.psid);
      setLoading(false);
      if (response?.code === 200) {
        if (response.data?.includes(employeeDetailsForm?.businessArea?.value)) {
          setEmpIdVerified(true);
        } else {
          failureToast("Employee ID not found in the selected BU. Try another");
        }
      } else {
        setErrorWhile(true);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const isAllTransactionDetailsFilled = (form) => {
    return (
      form?.transactionType !== "" &&
      form?.reason !== "" &&
      form?.sapCostCenter !== ""
    );
  };

  return (
    <div>
      {(isDropdownLoading || isLoading) && <ALoader position="fixed" />}
      <EmployDetailsForm
        dropdown={dropdown}
        employeeFormHandler={employeeFormHandler}
        sapCostDropdown={sapCostDropdown}
        form={employeeDetailsForm}
        verifyEmpIdHandler={verifyEmpIdHandler}
        isErrorWhileVerify={isErrorWhileVerify}
        isEmpIdVerified={isEmpIdVerified}
        academicType={academicType}

      />
      <SelectMaterialForm
        form={employeeDetailsForm}
        setFormHandler={employeeFormHandler}
        selectedMaterials={selectedMaterials}
        setSelectedMaterials={setSelectedMaterials}
        selectedNonBarcodedMaterials={selectedNonBarcodedMaterials}
        setSelectedNonBarcodedMaterials={setSelectedNonBarcodedMaterials}
        issueStockHandler={issueStockHandler}
        loading={isLoading}
        setLoading={setLoading}
        isAllTransactionDetailsFilled={isAllTransactionDetailsFilled(
          employeeDetailsForm
        )}
        isDlp={isDlp}
      />
      <IssueStockSuccessPrompt
        isOpen={issuedSuccess}
        setIsOpen={setIssuedSuccess}
        responseData={successResponse}
        message="Your branch consumption ID"
      />
      <IssueStockConfirmation
        open={issueStockConfirmation}
        setOpen={setIssueStockConfirmation}
        onAgree={onAgree}
        type = {type}
        message="Do you want to issue stock as per the submitted details?"
      />
    </div>
  );
};

export default IssueStockForm;
